import React from 'react';
import styled from 'styled-components';
import Logo from '../Resources/Icons/LogoIcon.png'
import PhoneIcon from '../Resources/Icons/PhoneIcon.png'
import InstaIcon from '../Resources/Icons/InstaIcon.png'
const MobileMenu = styled.div`
  position: fixed;
  top:0px;
  width: 100%;
  max-height: 8vh;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  z-index:2000;
 `
const MenuSlide = styled.div`
position: fixed;
right: 0px;
height: calc(100vh - 60px);
background:rgba(158, 158, 158, 0.78);
width:  100%;
display: flex;
flex-direction: column;
`
const ItemSlide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width:  100%; 
  height: 10vh;
  background: rgba(44, 44, 44, 0.81);
  border: solid 2px white;
  color: white;

  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
`
const Navwrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  max-width: ${props => props.$mobile ? '' : '1800px'};
  margin: auto;
  padding: 0 20px;
`
const NavIcon = styled.div`
  display: block;
  left: 5vw;
  top: 12px;
  height: ${props => props.$logo ? '40px;' : '30px'};
  width: ${props => props.$logo ? '40px;' : '30px'};
  background-image: url(${props => props.$icon});
  background-size: contain;
  margin-right: 5px;
`
const NavInfo = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 60%;
  
  a:link{
    color: black;
  }
  a:visited {
  color: black;
}
`
const NavHam = styled.div`

`
const CCClick = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
`

const ContactNumber = "437-345-6775";
const Instagram = "@1HandySham";

function Nav(props) {
  const menuClick = (props) => {
    props.setOpen(!props.isOpen)
  }
  const itemClick = (e, props) => {
    const element = document.getElementById(e.target.id + 'Container');
    if (e.target.id === 'MenuSlide') {
      props.setOpen(!props.isOpen)
    }
    else {
      document.body.style.overflow = 'auto';
      props.setOpen(!props.isOpen)
      if (e.target.id === 'Home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      else {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

  }
  return (
    <>
      <MobileMenu >
        <Navwrap >
          <NavIcon $icon={Logo} $logo={true}/>
          <NavInfo >
            <CCClick href='tel:437-345-6775'>
              <NavIcon $icon={PhoneIcon} />
              {props.$mobile ? '' : ContactNumber}
            </CCClick>
            <CCClick href='https://www.instagram.com/1handysham/'>
              <NavIcon $icon={InstaIcon} />
              {props.$mobile ? '' : Instagram}
            </CCClick>
          </NavInfo>
          <NavHam>
            <div id="hamburger-2"
              className={props.isOpen ? "hamburger is-active " : "hamburger"}
              onClick={() => menuClick(props)}>
              <span className="line"></span>
              <span className="line"></span>
              <span className="line"></span>
            </div>
          </NavHam>
        </Navwrap>
        {props.isOpen ?
          <MenuSlide
            id='MenuSlide'
            $mobile={props.$mobile}
            onClick={(e) => itemClick(e, props)}>
            <ItemSlide id='Home' >Home</ItemSlide>
            <ItemSlide id='About'>About</ItemSlide>
            <ItemSlide id='Projects'>Projects</ItemSlide>
            <ItemSlide id='Contact'>Contact</ItemSlide>
          </MenuSlide>
          :
          ''}
      </MobileMenu>
    </>
  )
}

export default Nav;